import { COUNTRY_CODE_NAME_DICT } from '../dictionaries/countryDictionary';
import { GooglePlace } from 'utils/interfaces/place';
import { Place } from 'utils/interfaces/announcementForm';

export const countryToCode = (countryName: string) => {
   const countryRow = Object.entries(COUNTRY_CODE_NAME_DICT).find(([code, namesRow]) => {
      return (Object.keys(namesRow) as (keyof typeof namesRow)[]).find(
         lang => namesRow[lang] === countryName,
      );
   });
   return countryRow ? countryRow[0] : countryName;
};

export const countryPlaceIdToCode = (placeId: string) => {
   const countryRow = Object.entries(COUNTRY_CODE_NAME_DICT).find(
      ([code, countryPlaceId]) => placeId === countryPlaceId,
   );

   // return code or given id if country with this id not found
   return countryRow ? countryRow[0] : placeId;
};

export const codeToCountry = (countryCode: string) => {
   return COUNTRY_CODE_NAME_DICT[countryCode] ? COUNTRY_CODE_NAME_DICT[countryCode] : countryCode;
};

export const getPlaceFromMapLocalization = (place: GooglePlace): Place => {
   const placeId = place.value.place_id;
   const mainText = place.value.structured_formatting.main_text;
   const secondaryText = place.value.structured_formatting.secondary_text;

   if (!secondaryText) {
      return {
         placeId,
         country: mainText,
      };
   }

   const lastCommaIx = secondaryText.lastIndexOf(',');
   const country = lastCommaIx != -1 ? secondaryText.substring(lastCommaIx + 2) : secondaryText;
   return {
      placeId,
      city: mainText,
      country: country,
   };
};

export const getLocaleForGoogleApi = (nextLocale: string | undefined) =>
   ({
      pl: 'pl',
      en: 'en',
      de: 'de',
      cz: 'cs',
      fr: 'fr',
      ru: 'ru',
      es: 'es',
   }[nextLocale || 'en']);
